<style>
@import './assets/css/style.css';

.showcase--after-checker-offers .showcase-wrapper {
    margin-bottom: 56px;
}

@media (max-width: 768px) {
    .showcase--after-checker-offers .showcase-wrapper {
        margin-bottom: 72px;
    }
}
</style>

<template>
    <div id="showcase-app-loadser">
        <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
    <div>
        <component :is="filterName" v-model="filterForm" />
    </div>
    <div style="position: relative;">
        <component
            :is="componentName"
            :class="{ 'showcase--after-checker-offers': isShowcaseAfterCheckerOffers }"
            :offers="offersFiltered"
            :main-offers="mainOffersFiltered"
            :sorting-offers="sortingOffersFiltered"
            :reserve-offers="reserveOffersFiltered"
            :active-primary-bucket="activePrimaryBucket"
            :settings="showcaseSettings"
            :checker-offers="checkerOffers"
            :checker-offers-placement="checkerOffersPlacement"
        />
        <checker-offers-block
            v-if="checkerOffersPlacement === 'after'"
            class="checker-offers-block--after"
            :offers="checkerOffers"
            :show-also-title="false"
        />
    </div>
</template>

<script>
import * as ShowcaseLoader from './assets/js/showcase.js'
import Showcases from './components';
import * as Data from './assets/js/data_params.js'
import CheckerOffersBlock from './components/CheckerOffersBlock.vue';

var formType = Data.get('type') || 'default';
var filterType = Data.get('filterType') || 'default';
var checkerPlacementShowcases = [
    'zaymtorus',
    'ozzaym',
    'wbzaym',
    'vamzaim',
    'zaymna5',
    'yazaym',
    'bzaym',
    'starzaym',
    'zaymstar',
    'zaymelo',
    'ultrazaem',
    '23zaym',
    'fixzaem',
    'kredifka',
];


export default {
    name: 'App',

    components: {
        ...Showcases,
        CheckerOffersBlock,
    },

    data: () => ({
        showcaseState: null,
        offers: [],
        mainOffers: [],
        sortingOffers: [],
        reserveOffers: [],
        activePrimaryBucket: 'main',
        checkerOffers: [],
        showcaseSettings: {},
        filterForm: {
            amount: null,
            period: null,
            rating: null,
            without_percent: null,
        },
        formType: formType,
        filterType: filterType,
    }),

    computed: {
        componentName() {
            return `v-showcase-${this.formType}`
        },
        filterName() {
            return `v-showcase-filter-${this.filterType}`
        },
        offersFiltered() {
            return this.filterOffers(this.offers);
        },
        mainOffersFiltered() {
            return this.filterOffers(this.mainOffers);
        },
        sortingOffersFiltered() {
            return this.filterOffers(this.sortingOffers);
        },
        reserveOffersFiltered() {
            return this.filterOffers(this.reserveOffers);
        },
        offersMixMode() {
            const settings = this.showcaseSettings || {};

            return String(
                settings.offers_mix_mode ||
                settings.offersMixMode ||
                settings.sort_method ||
                settings.sortMethod ||
                'first_checker'
            ).toLowerCase();
        },
        checkerOffersPlacement() {
            if (!checkerPlacementShowcases.includes(String(this.formType).toLowerCase())) {
                return 'before';
            }

            if (this.offersMixMode === 'mix') {
                return 'inline';
            }

            if (this.offersMixMode === 'first_self') {
                return 'after';
            }

            return 'before';
        },
        isShowcaseAfterCheckerOffers() {
            return this.checkerOffersPlacement === 'before' && this.hasCheckerOffers;
        },
        hasCheckerOffers() {
            return Array.isArray(this.checkerOffers) && this.checkerOffers.length > 0;
        },
    },

    methods: {
        applyShowcase(showcase) {
            const nextShowcase = ShowcaseLoader.mergeShowcase(this.showcaseState, showcase);

            if (!nextShowcase) {
                return;
            }

            this.showcaseState = nextShowcase;

            const settings =
                nextShowcase.settings ||
                nextShowcase.showcaseSettings ||
                nextShowcase.showcase?.settings ||
                nextShowcase.showcase?.params ||
                {};

            this.offers = nextShowcase.offers || [];
            this.mainOffers = nextShowcase.mainOffers || nextShowcase.offers || [];
            this.sortingOffers = nextShowcase.sortingOffers || [];
            this.reserveOffers = nextShowcase.reserveOffers || [];
            this.activePrimaryBucket =
                nextShowcase.activePrimaryBucket ||
                settings?.offers_replace_active_bucket ||
                'main';
            this.checkerOffers = nextShowcase.checkerOffers || [];
            this.showcaseSettings = settings;

            var $name = document.getElementById('showcase-app-name');
            var $rating = document.getElementById('showcase-app-rating');

            if (!!$name) {
                $name.innerHTML = nextShowcase.name;
            }

            if (!!$rating) {
                $rating.innerHTML = nextShowcase.creditRating;
            }
        },
        filterOffers(offers = []) {
            return (offers || []).filter(offer => {
                return Object.keys(this.filterForm).every(key => {
                    if (!this.filterForm[key]) return true;
                    switch (key) {
                        case 'period':
                        case 'amount': return this.filterForm[key] <= offer[key];
                        case 'without_percent': return (this.filterForm[key] && offer[key]) || !this.filterForm[key];
                        case 'rating': return offer[key] >= this.filterForm[key];
                        default: return this.filterForm[key] === offer[key];
                    }
                });
            });
        }
    },

    mounted() {
        const removeLoader = () => {
            const loader = document.getElementById('showcase-app-loadser');
            if (loader) loader.remove();
        };

        ShowcaseLoader.load()
            .then((showcase) => {
                this.applyShowcase(showcase);
                removeLoader();

                ShowcaseLoader.pollUntilReady(this.showcaseState, (nextShowcase) => {
                    this.applyShowcase(nextShowcase);
                }).catch(() => null);
            })
            .catch(() => {
                removeLoader();
                return null;
            });
    }
}
</script>
